import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { EstadosService } from '../../../services/estados.service';
import { FormBuilder } from '@angular/forms';
import { DimTabswipeComponent } from '../../../shared/dim-tabswipe/dim-tabswipe.component';
import { MessageService } from '@services';
import { validarCPF } from '@utils';

@Component({
  selector: 'app-produtos-agricolas',
  templateUrl: './produtos-agricolas.component.html',
  styleUrls: ['./produtos-agricolas.component.scss']
})
export class ProdutosAgricolasComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild('appTab', { static: false }) appTab: DimTabswipeComponent;
  @Output() applied = new EventEmitter<any>();
  @Output() opened = new EventEmitter();
  @Output() closed = new EventEmitter();
  @Input() dados: any;

  @Input() open = false;
  listaDefensivo: any[] = [];

  form = this.formBuilder.group({
    id: null,
    tipoGuia: [''],
    ufGuia: [''],
    serieGuia: [''],
    numeroGuia: ['']
  });

  formDefensivo = this.formBuilder.group({
    nReceituario: [''],
    cpfRespTec: ['']
  });

  tipoGuiaOptions = [
    { value: 1, label: 'GTA' },
    { value: 2, label: 'TTA' },
    { value: 3, label: 'DTA' },
    { value: 4, label: 'ATV' },
    { value: 5, label: 'PTV' },
    { value: 6, label: 'GTV' },
    { value: 7, label: 'Guia Florestal' }
  ];

  tabs = ['Guia de Trânsito', 'Defensivo Agrícola/Agrotóxico'];

  estadosOptions = [];
  currentTabIndex = 0;

  constructor(
    private estadoService: EstadosService,
    private formBuilder: FormBuilder,
    private messageService: MessageService
  ) { super(); }

  ngOnInit() {
    this.estadoService.get()
      .subscribe(res => {
        this.estadosOptions = res;
      });

    this.currentTabIndex = 0;
    setTimeout(() => { if (this.appTab) this.appTab.setTab(0); }, 0);
  }

  onOpened() {
    this.opened.emit();

    if (this.dados) {
      this.form.patchValue({
        tipoGuia: this.dados.tipoGuia ?? '',
        ufGuia: this.dados.ufGuia ?? '',
        serieGuia: this.dados.serieGuia ?? '',
        numeroGuia: this.dados.numeroGuia ?? ''
      });

      this.listaDefensivo = [...(this.dados.listaDefensivo ?? [])];

      if (this.listaDefensivo.length > 0) {
        this.currentTabIndex = 1;
      } else {
        const { tipoGuia, ufGuia, serieGuia, numeroGuia } = this.form.value;
        if (tipoGuia && ufGuia && serieGuia && numeroGuia) {
          this.currentTabIndex = 0;
        } else {
          this.currentTabIndex = 0;
        }
      }
    } else {
      this.form.reset();
      this.listaDefensivo = [];
      this.currentTabIndex = 0;
    }

    setTimeout(() => {
      if (this.appTab) this.appTab.setTab(this.currentTabIndex);
    }, 0);
  }

  onClosed() {
    this.closed.emit();
  }

  isTabBlocked(i: number): boolean {
    if (i === 0) {
      return this.listaDefensivo && this.listaDefensivo.length > 0;
    }
    if (i === 1) {
      const f = this.form.value;
      return !!(
        (f.tipoGuia && f.tipoGuia.toString().trim() !== '') ||
        (f.ufGuia && f.ufGuia.toString().trim() !== '') ||
        (f.serieGuia && f.serieGuia.toString().trim() !== '') ||
        (f.numeroGuia && f.numeroGuia.toString().trim() !== '')
      );
    }
    return false;
  }

  onSelectedIndexChange(targetIndex: number) {
    if (this.isTabBlocked(targetIndex)) {
      setTimeout(() => { this.currentTabIndex = this.currentTabIndex; }, 0);
      return;
    }

    this.currentTabIndex = targetIndex;
    if (this.appTab) this.appTab.setTab(targetIndex);
  }

  remover(index: number) {
    this.listaDefensivo.splice(index, 1);
  }

  removerTodos() {
    this.listaDefensivo = [];
  }

  salvar() {
    const { tipoGuia, ufGuia, serieGuia, numeroGuia } = this.form.value;
    const temGuia = tipoGuia || ufGuia || serieGuia || numeroGuia;

    if (temGuia) {
      if (!tipoGuia || !ufGuia || !numeroGuia) {
        this.messageService.error('Os campos em negrito são de preenchimento obrigatório na aba "Guia de Trânsito"!', 10000, 'Atenção! Preenchimento obrigatório.', true);
        return;
      }
    }

    const resultado = {
      tipoGuia,
      ufGuia,
      serieGuia,
      numeroGuia,
      listaDefensivo: this.listaDefensivo.map(d => ({
        nReceituario: d.nReceituario,
        cpfRespTec: d.cpfRespTec
      }))
    };

    this.applied.emit(resultado);
    this.closed.emit();
  }

  adicionarDefensivo() {
    const { nReceituario, cpfRespTec } = this.formDefensivo.value;

    if (!nReceituario || !cpfRespTec) {
      this.messageService.error('Os campos em negrito são de preenchimento obrigatório na aba "Defensivo"!', 10000, 'Atenção! Preenchimento obrigatório.', true);
      return;
    }

    if (!validarCPF(cpfRespTec)) {
      this.messageService.error('O CPF informado é inválido! Verifique a digitação.', 10000, 'Atenção! CPF Inválido.', true);
      return;
    }

    this.messageService.clearAll();

    if (this.formDefensivo.valid) {
      const defensivo = { nReceituario, cpfRespTec };

      this.listaDefensivo.push(defensivo);
      this.formDefensivo.reset();
    }
  }
}